import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/logo (1).png';

const Navbar = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState({ services: false, login: false });

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleDropdown = (menu) => {
    if (isMobileView) {
      setDropdownOpen((prev) => ({ ...prev, [menu]: !prev[menu] }));
    }
  };

  return (
    <>
      {isMobileView && isSidebarOpen && (
        <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
          <button className="close-btn" onClick={toggleSidebar}>×</button>
          <ul className="sidebar-links">
            <li><Link to="/" onClick={toggleSidebar}>Home</Link></li>
            <li><Link to="/aboutus-knowmore" onClick={toggleSidebar}>About Us</Link></li>
            <li className="dropdown-container">
              <Link to="/services" onClick={toggleSidebar}>Services</Link>
              <ul className={`services-dropdown ${dropdownOpen.services ? 'show' : ''}`}>
                <li><Link to="/services/accounting-financial-reporting" onClick={toggleSidebar}>Accurate Accounting</Link></li>
                <li><Link to="/services/tax-planning-compliance" onClick={toggleSidebar}>Strategic Tax Solutions</Link></li>
                <li><Link to="/services/wealth-investment-management" onClick={toggleSidebar}>Wealth Mastery</Link></li>
                <li><Link to="/services/loan-credit-card" onClick={toggleSidebar}>Financing Solutions</Link></li>
                <li><Link to="/services/business-advisory-consulting" onClick={toggleSidebar}>Business Growth Consulting</Link></li>
                <li><Link to="/services/data-analytics-reporting" onClick={toggleSidebar}>Advanced Data Solutions</Link></li>
              </ul>
            </li>
            <li><Link to="/products" onClick={toggleSidebar}>Product Basket</Link></li>
            <li><Link to="/contact" onClick={toggleSidebar}>Contact Us</Link></li>
            <li className="dropdown-container">
              <Link to="#">Login</Link>
              <ul className="dropdown">
                <li><a href="https://ewa.njindiaonline.com/ewa/signup">Signup</a></li>
                <li><a href="https://ewa.njindiaonline.com/ewa/login">NJ Wealth</a></li>
              </ul>
            </li>
          </ul>
        </div>
      )}

      <nav className={`navbar ${isSticky ? 'sticky' : ''}`}>
        <div className="logo">
          <img src={logo} alt="Tax O Wealth" />
        </div>
        {isMobileView && (
          <button className="mobile-menu-toggle" onClick={toggleSidebar}>☰</button>
        )}
        <ul className={`nav-links ${isMobileView ? 'hide' : ''}`}>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/aboutus-knowmore">About Us</Link></li>
          <li className="dropdown-container">
            <Link to="/services">Services</Link>
            <ul className="services-dropdown">
            <li><Link to="/services/accounting-financial-reporting">Accurate Accounting</Link></li>
                <li><Link to="/services/tax-planning-compliance">Strategic Tax Solutions</Link></li>
                <li><Link to="/services/wealth-investment-management">Wealth Mastery</Link></li>
                <li><Link to="/services/loan-credit-card">Financing Solutions</Link></li>
                <li><Link to="/services/business-advisory-consulting">Business Growth Consulting</Link></li>
                <li><Link to="/services/data-analytics-reporting">Advanced Data Solutions</Link></li>
            </ul>
          </li>
          <li><Link to="/products">Product Basket</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
          <li className="dropdown-container">
            <Link to="#">Login</Link>
            <ul className="dropdown">
              <li><a href="https://ewa.njindiaonline.com/ewa/signup">SignUp</a></li>
              <li><a href="https://ewa.njindiaonline.com/ewa/login">NJ Wealth</a></li>
            </ul>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Navbar;
